import { ApplicationState } from '~/store/store';

export const getRoomState = (state: ApplicationState) => state.room;
